import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';
import Slider from '../components/Slider.jsx';
import '../styles/fonts.css';

const Inclusivity = () => {
	let IHPpic = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
	// let Inclu3 = 'https://static.igem.wiki/teams/5066/human-practice/inclu3.jpg';
	let Inclu5 = 'https://static.igem.wiki/teams/5066/human-practice/inclu5.jpg';
	let Daisy = "https://static.igem.wiki/teams/5066/human-practice/daisy.png";


	
	let sections = [
		{ id: 's1', name: 'Teaching Tools for the Visually Impaired' },
		{ id: 's2', name: 'Lesson for the visually impaired' },
	];

	const images = [
        { path: 'https://static.igem.wiki/teams/5066/human-practice/inclu4.jpg' },
        { path: 'https://static.igem.wiki/teams/5066/human-practice/inclu6.jpg' },
    ];

	const images2 = [
        { path: 'https://static.igem.wiki/teams/5066/human-practice/inclu1.jpg' },
        { path: 'https://static.igem.wiki/teams/5066/human-practice/inclu2.jpg' },
    ];

	const images3 = [
        { path: 'https://static.igem.wiki/teams/5066/human-practice/inclu7.jpg' },
        { path: 'https://static.igem.wiki/teams/5066/human-practice/youtube-profile.png' },
    ];

	return (
		<div>
			<PageHeader img={IHPpic} title={'Inclusivity'} customPicture={<img src={'https://static.igem.wiki/teams/5066/cover/wetlab.gif'} alt="Custom" className="w-44 h-44" />} />

			<div className='flex'>
				<Sidebar sections={sections} />
				{/* Main Content */}
				<div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>
					<div className='pb-12'>
						<section id='s1'>
							<h2 className='text-3xl font-bold text-[#C94C67]'>
								Teaching Tools for the Visually Impaired
							</h2>
							<div className='mt-4'>
								
								<p className=' mt-5 text-xl md:text-2xl font-bold text-black leading-relaxed'>
                                    Braille Comic Book
                                </p>
								<div className='grid justify-center'>
                            <img
                                src={Inclu5}
                                alt=''
                                className='mt-5 w-full md:w-[600px] h-auto rounded-lg shadow-lg'
                            />
							</div>
								<p className='mt-2 font-bold text-gray-700' font-bold>
									Description:
								</p>
								<p className='mt-2 text-gray-700'>
									Our engaging comic book educates children
									about the dangers of the dengue virus, the
									prevention of the dengue virus, and our
									project. To include all this, we have also
									produced a braille version to make this
									crucial information accessible to visually
									impaired youth. This innovative approach
									ensures that no child is left behind in
									learning about mosquito-borne diseases and
									how to protect themselves.
								</p>
								<p className='mt-2 font-bold text-gray-700' font-bold>
								Purpose:</p>
								<p className='mt-2 text-gray-700'>
									Through our braille comic book and strategic
									partnerships, we aim to empower visually
									impaired children with the knowledge and
									skills to protect themselves and their
									communities from the devastating effects of
									dengue fever. By making this educational
									resource accessible and adaptable to diverse
									contexts, we can bridge the gap for visually
									impaired students, making literature and
									knowledge more accessible, thus enriching
									their personal and educational lives.
								</p>
								<p className='mt-2 text-gray-700'>
									To expand our impact, we would like to
									collaborate with a braille printing company
									and produce as many braille versions of our
									comic books as possible so that other
									visually impaired people can access the same
									resources we provide to those near us.
								</p>
								<br></br>
								<p className='text-2xl md:text-2xl font-bold text-gray leading-relaxed'>
									Audiobook
								</p>
								<div className='mt-5 grid justify-center'>
								<div className=' w-[600px]'>
								<Slider images={images3}  classname='w-1/2 h-auto' />						
								</div>
								</div>

								<p className='mt-2 font-bold text-gray-700' font-bold>
									Description:
								</p>
								<p className='mt-2 text-gray-700'>
									In our commitment to accessibility, we have
									also recorded an audiobook version of our
									comic book, with the story versions. This
									audiobook is currently available in English
									and Mandarin, with plans to expand into
									additional languages.
								</p>
								<p className='mt-2 font-bold text-gray-700' font-bold>
								Purpose:</p>
								<p className='mt-2 text-gray-700'>
									The audio format complements the braille version, providing another layer of accessibility for children who may benefit from auditory learning. We in to reach people in various countries, ensuring that vital information about dengue prevention is accessible to diverse populations. Through our braille comic book and audiobook, we aim to empower visually impaired children worldwide with the knowledge and skills necessary to protect themselves and their communities from the devastating effects of dengue fever. After receiving the feedback from our visually impaired students, they mentioned their interest in the audiobook and how they wish for it to be available in bookstores, such as Daisy Library from the Taiwan Digital Talking Book Association. Daisy Library was an online bookstore that provides abundant audiobook resources for the visually impaired, so to expand our impact we contacted Daisy Library to make our audiobook available online. To listen to our audiobooks in different languages, check out our YouTube channel, GEMS_Taiwan!
								</p>
								<div className='grid justify-center'>
								<img
                                src={Daisy}
                                alt=''
                                className='mt-5 w-full md:w-[600px] h-auto rounded-lg shadow-lg'
                            />
								</div>
								<br></br>
								<p className='text-2xl md:text-2xl font-bold text-gray leading-relaxed'>
									Collaboration with HKSSC
								</p>
								<p className='mt-2 text-gray-700'>
								In an effort to improve relations between different teams, we’ve reached out to different iGEM teams to plan a collaboration. We sent a version of our English audiobook to the iGEM team HKSSC in order to ask them to translate it into Cantonese. Through this initiative, we hope to not only improve the bonds between the iGEM community, but also open up a resource that can bypass the language barrier and reach more people. The Cantonese version of our audiobook can be accessed through our YouTube channel, GEMS_Taiwan.
								</p>
								<br></br>
								<p className='text-2xl md:text-2xl font-bold text-gray leading-relaxed'>
									Biology Models
								</p>
								<div className='mt-5 grid justify-center'>
								<div className=' w-[600px]'>
								<Slider images={images}  classname='w-1/2 h-auto' />
								</div>
								</div>
								<p className='mt-2 font-bold text-gray-700' font-bold>
									Description:
								</p>
								<p className='mt-2 text-gray-700'>
									In our mission to promote widespread and inclusive education, when teaching biology we gave the students a double helix structure model to let them feel the structure. In addition, we made a plasmid model out of clay and made a part of the plasmid to switch out the original part. We let them touch that as well to figure out where certain components of the structure we taught them were located and the process of inserting different genes into the plasmid model. 
								</p>
								<p className='mt-2 font-bold text-gray-700' font-bold>
								Purpose:</p>
								<p className='mt-2 text-gray-700'>
Due to their vision impairment, our lesson plan was structured around other senses such as their sense of touch to provide an alternative, more hands on learning to help them better understand the shape and what they are supposed to be looking at. Through our emphasis on tactile learning experiences, students can feel the different contours and textures of different models and shapes, allowing them to picture it mentally. They can carry out processes that we do in the lab like switching out genes in plasmids. This can give them access to hands-on biology and exposure to synthetic biology, allowing them to explore their interests in this field. 
								</p>
							</div>
						</section>
					</div>

					<div className='pb-12'>
						<section id='s2'>
							<h2 className='text-3xl font-bold text-[#C94C67]'>
								Lesson for the Visually Impaired
							</h2>
							<div className='mt-10 grid justify-center'>
								<div className=' w-[600px]'>
								<Slider images={images2} classname='w-1/2 h-auto'   />
								</div>
								</div>
							<p className='mt-2 text-gray-700'>
								To work towards being inclusive towards minorities, we found our opportunity at a visually impaired school and taught DNA, genes, plasmid, and recombinant DNA technology while promoting dengue awareness and introducing our project. During the part where we educated them about our project, we brought out our gravitrap prototypes for them to touch, thus making the lesson more interactive. Likewise, during the part where we teach them about the basics of biology and recombinant DNA technology, we used the double helix for them to touch and the plasmid model for them to exercise the process of extracting the part of the plasmid and inserting a different part as a replacement. Additionally, for dengue awareness, we utilized our audiobook and braille version of our comic book to educate them on the issue of dengue awareness as well as introduce our solution in an engaging way (by telling a story). We held an interview session that included Q&As and feedback from our students. They gave us insight into how we can help others like them and make resources available to them like our comic book and audiobook. They shared their experience on how they usually access audio books through Daisy Library, so we contacted Daisy Library for further collaboration on publishing our audio book in the platform to expand the impact of teaching resources. 
							</p>
							<br></br>
							<a
                                    href="https://static.igem.wiki/teams/5066/human-practice/visually-impaired-people-teaching-plan-1.pdf"
                                     target="_blank"
									rel="noopener noreferrer"
                                    className="font-bold text-[#d77d91] hover:underline hover:text-[#C94C67] transition-colors duration-200"
                                >
                                    Teaching Plan
                                </a>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Inclusivity;
